import { render, staticRenderFns } from "./STableHistoryClientComp.vue?vue&type=template&id=a9c028da&"
import script from "./STableHistoryClientComp.vue?vue&type=script&lang=js&"
export * from "./STableHistoryClientComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports